import { render, staticRenderFns } from "./bindingStudents.html?vue&type=template&id=0481330f&"
import script from "./bindingStudents.js?vue&type=script&lang=js&"
export * from "./bindingStudents.js?vue&type=script&lang=js&"
import style0 from "./bindingStudents.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports